
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, limit, labourType, productType} from "../../../../comman/config";
import Loader from "../../../../comman/Loader";
import { PencilIcon, XCircleIcon } from '@heroicons/react/outline';
import {DateFilter} from "../../../../comman/DateFilter.js";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";
import * as XLSX from 'xlsx';


function List() {

    const [companyList, setCompanyList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [name, setName] = useState('');
    

    const navigate = useNavigate();

    useEffect(() => {
        getCompanyList();
        
    }, [page, fromDate,toDate, name]);


    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }

    const getCompanyList = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/admin/profile/company/list?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&name=${name}`);
        setPopupOpen(false);
        setCompanyList(response.data.data);
        setTotalItem(response.data.totalItem);
    }

    const deleteCompany = async (id) => {
        try {
            await axios.delete(`${baseUrl}/admin/profile/company/delete/${id}`);
            window.location.reload();
        } catch (error) {
            console.log(error);
        }

    };

   

    const editCompany = async (id) => {
        navigate(`/admin/profile/company/edit/${btoa(id)}`, { state: companyList.filter(item => item.id == id) });
    }

    const handelFilterChange= (fromDate, toDate, clear, today, name) => {
        setFromDate(fromDate);
        setToDate(toDate);  
        setName(name);
    };

    const companyTypeName = (type) => {
        return labourType.find((val) => val.value == type)?.label ?? "";
    }

    const productTypeName = (type) => {
        return productType.find((val) => val.value == type)?.label ?? "";
    }

    const exportToExcel = async () => {
        setPopupOpen(true);
        const response = await axios.get(
            `${baseUrl}/admin/profile/company/list?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&name=${name}&type=true`
        );
        setPopupOpen(false);
    
        const exportData = response.data.data.map((item) => ({
            Date: item.date,
            Name: item.name,
            Address: item.address,
            'Company Type': companyTypeName(item.company_type),
            'Product Type': productTypeName(item.product_type)
        }));
    
        // Add total row
        exportData.push({
            Date: '',
            Name: '',
            Address: '',
            'Company Type': 'Total',
            'Product Type': exportData.length.toString(),
        });
    
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'CompanyList');
        XLSX.writeFile(workbook, 'Company_List.xlsx');
    };
    

    return (
        
        <div className="p-4">
            {popupOpen && (
                     <Loader /> 
                ) }
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Company List</h1>
                <div>
                <button
            onClick={exportToExcel}
            className="px-4 py-2 bg-green-700 text-white rounded-md mr-2 hover:bg-green-600 focus:outline-none focus:ring focus:ring-green-200"
        >
            Export to Excel
        </button>
                    <Link to="/admin/profile/company/add">
                        <button className="px-4 py-2 bg-blue-900 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Company</button>
                    </Link>
                </div>
            </div>
            
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <DateFilter 
                handleFilterChange={handelFilterChange} 
            />
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                        <th scope="col" className="px-6 py-3 border">Date</th>
                        <th scope="col" className="px-6 py-3 border">Name</th>
                        <th scope="col" className="px-6 py-3 border">Address</th>
                        <th scope="col" className="px-6 py-3 border">Type</th>
                        <th scope="col" className="px-6 py-3 border">Product Type</th>
                        <th scope="col" className="px-6 py-3 border">Action</th>
                        </tr>
                       
                    </thead>
                    <tbody>
                    {companyList.map((item) => (
                        <tr key={item.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{item.date}</th>
                            <td className="px-6 py-4">{item.name}</td>
                            <td className="px-6 py-4">{item.address}</td>
                            <td className="px-6 py-4">{companyTypeName(item.company_type)}</td>
                            <td className="px-6 py-4">{productTypeName(item.product_type)}</td>
                           
                           
                            <td className="px-6 py-4 flex">
                                    <a 
                                    onClick={() => editCompany(item.id)}
                                    className="font-medium text-blue-600 dark:text-blue-500 hover:underline mr-2">
                                        <PencilIcon className="w-4 h-4 inline-block" /> {/* Edit icon */}
                                    </a>
                                    <a href="#" onClick={() => deleteCompany(item.id)} className="font-medium text-red-600 dark:text-red-500 hover:underline">
                                        <XCircleIcon className="w-4 h-4 inline-block" /> 
                                    </a>
                                </td>
                        </tr>))}
           
                    </tbody>
                </table>
            </div>
            {totalItem > limit && (<Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalItem}
              pageRangeDisplayed={5}
              onChange={handlePageChange.bind(this)}
            />)}
        </div>
  );
}

export default List;